var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colRefForm"},[_c('div',{staticClass:"txtform"},[_c('div',{staticClass:"img-div"})]),_c('div',{staticClass:"row"})])}]

export { render, staticRenderFns }